const FMLayouts = {
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnabled: true,
    acceptCustomValue: true,
    gridKey: 'FD9A2713-71A9-46AA-8D6C-46F9AF4C05BD',
    params: {
        module: "FM",
        lookupType: "Fmdispatch",
        showLookupGrid: true,
    },
    columns: [
    { caption: "Profile Code" ,dataField: "name", dataType: "string", visible: false },
    { caption: "Description" ,dataField: "description", dataType: "string", visible: false },
    ]
}

export {
    FMLayouts,
}